module.exports = __webpack_public_path__ + "static/media/premium.9ec72fbb.svg";